import FarmList from './farms.list';

export const FarmStores = {
  list: FarmList,
};
